import { render, staticRenderFns } from "./TitleListsImport.vue?vue&type=template&id=0d2a9fd8&"
import script from "./TitleListsImport.vue?vue&type=script&lang=js&"
export * from "./TitleListsImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports